
<div class="d-inline-flex p_relative">
  <app-label-text class="mb-0" :title="title"></app-label-text>
  <app-normal-text class="mr-3" :text="text"></app-normal-text>
</div>
